// src/App.js
import React from 'react';
import FullMapPage from './pages/FullMapPage';
import RulesPage from './pages/RulesPage';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './AuthContext';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import LeaderboardsPage from './pages/LeaderboardsPage';
import ProfilePage from './pages/ProfilePage';
import VerifyPage from './pages/VerifyPage';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/player/:playerId/profile" element={<ProfilePage />} />
            <Route path="/verify" element={<VerifyPage />} />
            <Route path="/leaderboards" element={<LeaderboardsPage />} />
            <Route path="/leaderboards" element={<Navigate to="/leaderboards/player/block-coverage" replace />} />
            <Route path="/leaderboards/:type/:metric" element={<LeaderboardsPage />} />
            <Route path="/rules" element={<RulesPage />} />
            <Route path="/map" element={<FullMapPage />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;